import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import './Logs.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import useNotification from '../../../hooks/useNotification';
import CustomToolbar from 'components/CustomToolbar';

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

function CustomToolbarWithReload(props) {
    return (
        <CustomToolbar {...props}>
            <IconButton title='Ricarica dati' onClick={() => {props.getLogs()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
        </CustomToolbar>
    );
}

const LogsCell = (params) => {
    const formatDataInsToShow = (data) => {
        if(!data)return "";
        let dd = data.substring(6,8);
        let month = data.substring(4,6);
        let anno = data.substring(0,4);
        let hour = data.substring(8,10);
        let mins = data.substring(10,12);
        let ss = data.substring(12, 14);
        let sss = data.substring(14,17);
        //return `${dd}/${month}/${anno} ${hour}:${mins}:${ss}.${sss}`
        //return new Date(`${anno}-${month}-${dd}T${hour}:${mins}:${ss}.${sss}Z`).toUTCString();
        let dateToRender = new Date(`${anno}-${month}-${dd}T${hour}:${mins}:${ss}.${sss}Z`);
        return dateToRender.toLocaleString("it-IT")
    }

    return(
        <div>
            {params.field === 'dataIns' ? formatDataInsToShow(params?.row['dataIns']?.S) : params?.value}
        </div>
    )
}

function Logs(props) {
    const auth = useContext(AuthContext);
    const { logs, setLogs } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [logsLoading, setLogsLoading] = useState(true);

    const columns = [
        {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Log Id', type: 'string', width: 150, align: 'right', headerAlign: 'right', renderCell: (params) => LogsCell(params), valueGetter: (params) => params?.S},
        {field: 'dataIns', headerClassName: 'header-cell datains', headerName: 'Data Inserimento', type: 'date', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => LogsCell(params), valueGetter: (params) => formatDataIns(params?.S), valueFormatter: (params) => formatDataForCSV(params)},
        {field: 'deviceId', headerClassName: 'header-cell deviceId', headerName: 'Id Impianto', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => LogsCell(params), valueGetter: (params) => params?.S},
        {field: 'panel', headerClassName: 'header-cell panel', headerName: 'Id Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => LogsCell(params), valueGetter: (params) => params?.S},
        {field: 'source', headerClassName: 'header-cell sourcetab', headerName: 'Rotta', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => LogsCell(params), valueGetter: (params) => params?.S},
        {field: 'language', headerClassName: 'header-cell lang', headerName: 'Lingua', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => LogsCell(params), valueGetter: (params) => params?.S},
        {field: 'ipFrom', headerClassName: 'header-cell ipFrom', headerName: 'IP', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => LogsCell(params), valueGetter: (params) => params?.S}
    ]

    useEffect(() => {
        if(!logs.length){
            getLogs();
        }else{
            setLogsLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getLogs();
        }
    }, [props.city])

    const getLogs = async() => {
        try {
            setLoading(true);
            setLogsLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-logs',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setLogs(response.data.dataToReturn);
            setLogsLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLogsLoading(false);
            setLoading(false);
        }
    }

    const formatDataIns = (data) => {
        if(!data)return "";
        let dd = data.substring(6,8);
        let month = data.substring(4,6);
        let anno = data.substring(0,4);
        let hour = data.substring(8,10);
        let mins = data.substring(10,12);
        let ss = data.substring(12, 14);
        let sss = data.substring(14,17);
        //return `${dd}/${month}/${anno} ${hour}:${mins}:${ss}.${sss}`
        //ritorna valore in timezone corrente
        let dataInsDate = new Date(`${anno}-${month}-${dd}T${hour}:${mins}:${ss}.${sss}Z`);
        //la timezone è sempre la corrente ma viene forzato ad esserre come un valore in utc
        return new Date(dataInsDate.getTime() + dataInsDate.getTimezoneOffset() * 1000 * 60);
    }

    const formatDataForCSV = (data) => {
        if(!data)return "";
        let dd = data.getDate().toString().padStart(2, "0");
        let month = (data.getMonth()+1).toString().padStart(2, "0");
        let anno = data.getFullYear();
        let hour = data.getHours().toString().padStart(2, "0");
        let mins = data.getMinutes().toString().padStart(2, "0");
        let ss = data.getSeconds().toString().padStart(2, "0");
        let sss = data.getMilliseconds().toString().padStart(3, "0");
        return `${dd}/${month}/${anno} ${hour}:${mins}:${ss}.${sss}`
    }

    return (
        <div className='component-container logs'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={logs}
                        columns={columns}
                        className="logs-table"
                        loading={logsLoading}
                        rowHeight={30}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        disablePivoting
                        showToolbar
                        slots={{
                            toolbar: CustomToolbarWithReload,
                        }}
                        slotProps={{
                            toolbar: {
                                elements: ['columns', 'filters', 'export', 'quickFilter'],
                                getLogs,
                                printOptions: { disableToolbarButton: true },
                                csvOptions: { fileName: `logs_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                                excelOptions: { fileName: `logs_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                            }
                        }}
                    />
                </ThemeProvider>
            </div>
        </div>
    )
}

export default Logs